import { render, staticRenderFns } from "./finance-dividend-list.vue?vue&type=template&id=29032fda&"
import script from "./finance-dividend-list.vue?vue&type=script&lang=js&"
export * from "./finance-dividend-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports